import {ProductDataItem} from "../types/StudioAPITypes";
import {SORT_ATTRIBUTE} from "./constants";

export type SortTuple<U, D> = [U, D];

export type SortReturn = -1 | 0 | 1 | number;

export function sortBy<I>(key: string, list: I[]) {

  switch (key) {
    case SORT_ATTRIBUTE.a_z.key:
      return sortByNames(list)
      break;
    case SORT_ATTRIBUTE.z_a.key:
      return sortByNames(list).reverse();
      break;
    case SORT_ATTRIBUTE.lastEdited.key:
      return sortByDates(list as any)
      break;
    default:
      return list;
      break;
  }
}

/**
 * Sort by dates, starting with the newest
 *
 * @param {ProductDataItem[]} list
 * @returns {ProductDataItem[]}
 */
export function sortByDates(list: ProductDataItem[]): ProductDataItem[] {
  return decoratedSort<ProductDataItem, number>(list, (item: ProductDataItem) => {
    return new Date(item.lastOpenDate).valueOf();
  }).reverse();
}

/**
 * Sort by names alphabetically
 *
 * @param {I[]} list
 * @returns {I[]}
 */
export function sortByNames<I>(list: I[]): I[] {
  return decoratedSort<I, string>(list, (item: I) => {
    const anyItem = <any>item;
    return anyItem.name.toLowerCase().replace(/^(the|an|a)\s(.*)$/, "$2");
    }, (a: SortTuple<I, string>, b: SortTuple<I, string>) => {
    return a[1].localeCompare(b[1]);
  })
}

/**
 * Implementation of a Schwartzian Transform
 * https://en.wikipedia.org/wiki/Schwartzian_transform
 *
 * @param {U[]} sortables
 * @param {(item: U) => D} decorator
 * @param {(a: SortTuple<U, D>, b: SortTuple<U, D>) => SortReturn} sort
 * @returns {U[]}
 */
export function decoratedSort<U, D>(sortables: U[], decorator: (item: U) => D, sort?: (a: SortTuple<U, D>, b: SortTuple<U, D>) => SortReturn): U[] {
  return sortables.map<SortTuple<U, D>>((undecorated: U) => {
    return [undecorated, decorator(undecorated)];
  }).sort((a: SortTuple<U, D>, b: SortTuple<U, D>) => {
    if (sort) {
      return sort(a, b);
    }

    // Most generic sort possible if none is passed in
    return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
  }).map((tuple: SortTuple<U, D>) => {
    return tuple[0];
  });
}
